import Device from '@/helpers/Device';
import MediaHandler from '@/helpers/MediaHandler';
import Registration from '@/helpers/Registration';
import Requests from '@/helpers/Request';
import { SOCKET_ACTIONS } from '@/helpers/SocketHandler';
import router from '@/router';

export default {
  namespaced: true,
  state: () => ({
    socket: null,
    isSocketConnected: false,
    heartBeat: undefined,
  }),
  mutations: {
    setSocket(state, socket) {
      state.socket = socket;
    },
    setState(state, { name, value }) {
      state[name] = value;
    },
    setSocketConnected(state, status) {
      state.isSocketConnected = status;
    },
    setHeartBeat(state, interval) {
      state.heartBeat = interval;
    },
  },
  actions: {
    init({ commit, dispatch, rootState, state }) {
      if (state.isSocketConnected && state.socket) {
        return Promise.resolve('Socket already initialized');
      }

      const url = `${process.env.SOCKET_BASE}/socket/client/${rootState.groupId}/${rootState.buildingId}/tv/${rootState.deviceId}`;
      const socket = new WebSocket(url);
      commit('setSocket', socket);

      state.socket.onopen = function(event) {
        console.log('SOCKET OPEN', event);
        commit('setSocketConnected', true);
        dispatch('heartBeat');
      };
      state.socket.onerror = function(event) {
        console.log('SOCKET ERR', event);
      };
      state.socket.onclose = function(event) {
        console.log('SOCKET CLOSED', event);
        commit('setSocketConnected', false);
        dispatch('clearHeartBeat');
        setTimeout(() => {
          dispatch('init');
        }, 2000);
      };
      /*state.socket.onmessage = function(event) {
        console.log('MESSAGE', JSON.parse(event.data));
        const data = JSON.parse(event.data);
        if (data[0] === 'experienceEvent') {
          dispatch('handleSocketCall', data);
        }
        // --- Heartbeat Handling ---
        if (Object.keys(data).length === 0) {
          console.log('Heartbeat {} empfangen');
          try {
            state.socket.send('{}');
            console.log('Heartbeat {} gesendet');
          } catch (e) {
            console.error('Fehler beim Heartbeat-Senden:', e);
          }
          return;
        }
      };*/
      state.socket.onmessage = function(event) {
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          console.warn("Ungültige Nachricht:", event.data);
          return;
        }

        // Heartbeat erkennen
        if (Object.keys(data).length === 0) {
          console.log("Heartbeat {} empfangen");
          try {
            state.socket.send('{}');
          } catch (e) {
            console.error("Fehler beim Heartbeat-Antworten:", e);
          }
          return;
        }

        // Normale Nachrichten
        if (data[0] === 'experienceEvent') {
          dispatch('handleSocketCall', data);
        }
      };
      return Promise.resolve();
    },

/*
  heartBeat({ state, commit }) {
    // alle 30 Sekunden einen Heartbeat senden
    const interval = setInterval(() => {
      if (state.isSocketConnected && state.socket) {
        try {
          // entweder Protokoll-Ping
          state.socket.send('{}'); 
          // oder wenn du auf Protokollebene willst:
          // state.socket.ping() <-- geht aber in Browser nicht, nur Node!
        } catch (e) {
          console.error('Heartbeat failed:', e);
        }
      }
    }, 30000);

    commit('setHeartBeatInterval', interval);
  },

  clearHeartBeat({ state, commit }) {
    if (state.heartBeatInterval) {
      clearInterval(state.heartBeatInterval);
      commit('setHeartBeatInterval', null);
    }
  }
*/


    heartBeat({ state, commit }) {
      if (state.heartBeat) return;
      const heartBeat = setInterval(() => {
        state.socket.send('{}');
        //console.log("HEARTBEAT SEND");
      }, 40000);
      //console.log("HEARTBEAT STARTED");
      commit('setHeartBeat', heartBeat);
    },
    clearHeartBeat({ state, commit }) {
      clearInterval(state.heartBeat);
      commit('setHeartBeat', undefined);
    },
    handleSocketCall({ dispatch }, data) {
      console.log('SOCKET CALL: ', data);
      const message = data[0];
      const context = data[1];
      dispatch(
        'notification/socket',
        {
          title: message,
          message: JSON.stringify(context, null, 2),
        },
        { root: true }
      );
      dispatch('handleActionCall', context);
    },
    handleActionCall({ dispatch }, context) {
      switch (context.action) {
        case SOCKET_ACTIONS.OPEN_APP:
          dispatch('navigation/handleOpenApp', context, { root: true });
          break;
        case SOCKET_ACTIONS.RUN_VIDEO:
          const response = MediaHandler.assembleSocketVideoQuery(context);
          router.push(response);
          break;
        case SOCKET_ACTIONS.OPEN_SOURCE_APP:
          dispatch('navigation/handleOpenSourceApp', context.sourceapp_id, {
            root: true,
          });
          break;
        case SOCKET_ACTIONS.SET_LANGUAGE:
          dispatch('lang/set', context.language, { root: true });
          break;
        case SOCKET_ACTIONS.SET_TV_PACKAGE:
          dispatch('device/update', null, { root: true });
          break;
        case SOCKET_ACTIONS.TURN_OFF:
          dispatch('device/turnOff', null, { root: true });
          break;
        case SOCKET_ACTIONS.TURN_ON:
          dispatch('device/turnOn', null, { root: true });
          break;
        case SOCKET_ACTIONS.OPEN_WELCOME_SCREEN:
          dispatch('welcome/init', context.guest_data, { root: true });
          break;
        case SOCKET_ACTIONS.OPEN_HOME:
          router.push({ name: 'Home' });
          break;
        case SOCKET_ACTIONS.REBOOT:
          Device.reboot();
          break;
        case SOCKET_ACTIONS.UPDATE:
          location.reload(true);
          break;
        case SOCKET_ACTIONS.RUN_SOURCE:
        case SOCKET_ACTIONS.RUN_CHANNEL:
        default:
          dispatch(
            'notification/error',
            {
              title: context.action,
              message: JSON.stringify(context, null, 2),
            },
            { root: true }
          );
      }
    },
  },
  getters: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/socket.js